import { moduleProviderFactory } from "core/providers";
import { FacilityOrderNewFlowInsurancePreview } from "application/facility-order-new-flow-insurance/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.facility-order",
				pattern: "/facility-orders",
                children: [
					{
						name: "master.app.main.facility-order.facility-order-new-flow.insurance-preview",
						pattern: "/:id/new-flow/insurance",
						authorization: "facilityOrderSection.update",
						component: FacilityOrderNewFlowInsurancePreview,
						data: {
							// title: "FACILITY_ORDER.CRUMB.INSURANCE_REVIEW",
							crumbs: [
								{
									title: "FACILITY_ORDER.CRUMB.INSURANCE_REVIEW",
									route: 'master.app.main.facility-order.facility-order-new-flow.insurance-preview'
								}
							],
							back: "master.app.main.facility-order.facility-order-new-flow.list",
						},
					}
                ]
            }
        ],
		menu: [
            {
				title: "MENU.FACILITY_ORDERS",
				icon: "package",
				authorization: "coreUserSection.read",
				order: 5,
				subMenu: [
					{
						title: "MENU.FACILITY_ORDERS_SUB",
						authorization: "facilityOrderSection.read",
						route: "master.app.main.facility-order.facility-order-new-flow.list",
						order: 2,
					}
				]
			},
        ]
    });
})();
